<template>
	<div class="control">
		<RuleModeAlert
			@close="hideRuleModeAlert()"
			@reTry="controlClick(1)"
			v-if="isShowRuleModeAlert"
		></RuleModeAlert>
		<ConnectAlert
			:isFailed="isShowConnectFailed"
			:name="connectName"
			:connectRet="connectRet"
			@close="closeConnectAlert"
			v-if="isShowConnectAlert"
			:rule="rule"
		></ConnectAlert>
		<MessageTip
			v-if="messageFlag"
			:messageType="messageType"
			@closeMessageAlertClick="closeMessageAlertClick"
			@wakeupClick="wakeupClick"
			@showWakeupTips="showWakeupTips"
			@goPay="onPayClick"
		></MessageTip>
		<WakeUpTipsAlert
			@ignore="ignoreWakeUpTips"
			@wakeup="wakeupClick"
			@close="closeWakeUpTipsAlert"
			v-if="isShowWakeUpTipsAlert"
		></WakeUpTipsAlert>
		<WakeUpTipsSuccessAlert
			@close="closeWakeUpSuccessTipsAlert"
			@showWakeupTips="showWakeUpTipsAlert"
			v-if="isShowWakeUpSuccessTipsAlert"
		></WakeUpTipsSuccessAlert>
		<ServerTimesLimitAlert
			@onCancelClick="hideServerTimesLimitAlert(false)"
			@onPayClick="onPayClick"
			v-if="isShowServerTimesLimitAlert"
		></ServerTimesLimitAlert>
		<ServerTimesTipsAlert
			:times="leftTimes"
			@onCancelClick="hideServerTimesTipsAlert(false)"
			v-if="isShowServerTimesTipsAlert"
		></ServerTimesTipsAlert>
	</div>
</template>

<script>
import ConnectAlert from "@/components/ConnectAlert.vue";
import MessageTip from "@/components/MessageTip.vue";
import WakeUpTipsAlert from "@/components/WakeUpTipsAlert.vue";
import RuleModeAlert from "@/components/Node/RuleModeAlert.vue";
import ServerTimesLimitAlert from "@/components/Node/ServerTimesLimitAlert.vue";
import ServerTimesTipsAlert from "@/components/Node/ServerTimesTipsAlert.vue";
import WakeUpTipsSuccessAlert from "@/components/WakeUpTipsSuccessAlert.vue";
import { mapActions } from "vuex";
export default {
	data: function () {
		return {
			messageFlag: false,
			messageType: "",
			connectName: "",
			connectRet: "",
			rule: 0,
			leftTimes: 0,
			isShowConnectFailed: false,
			isShowConnectAlert: false,
			isShowWakeUpTipsAlert: false,
			isShowRuleModeAlert: false,
			isShowWakeUpSuccessTipsAlert: false,
			isShowServerTimesLimitAlert: false,
			isShowServerTimesTipsAlert: false,
		};
	},
	components: {
		ConnectAlert,
		MessageTip,
		WakeUpTipsAlert,
		WakeUpTipsSuccessAlert,
		RuleModeAlert,
		ServerTimesLimitAlert,
		ServerTimesTipsAlert,
	},
	props: ["item", "dev", "type"],
	methods: {
		...mapActions([
			"portal",
			"createTunnel",
			"startMapSrv",
			"sendUserlog",
			"webWakeup",
			"scan",
			"getServerTimes",
			"updateServerTimes",
		]),
		closeWakeUpSuccessTipsAlert: function (isShowMore) {
			let _that = this;
			_that.isShowWakeUpSuccessTipsAlert = false;
			if (!isShowMore) {
				_that.$emit("closeClick");
			}
		},
		showWakeUpSuccessTipsAlert: function () {
			let _that = this;
			_that.isShowWakeUpSuccessTipsAlert = true;
		},
		showServerTimesLimitAlert: function () {
			let _that = this;
			_that.isShowServerTimesLimitAlert = true;
		},
		hideServerTimesLimitAlert: function (isShowMore) {
			let _that = this;
			_that.isShowServerTimesLimitAlert = false;
			if (!isShowMore) {
				_that.$emit("closeClick");
			}
		},
		showServerTimesTipsAlert: function () {
			let _that = this;
			_that.isShowServerTimesTipsAlert = true;
		},
		hideServerTimesTipsAlert: function (isShowMore) {
			let _that = this;
			_that.isShowServerTimesTipsAlert = false;
			if (!isShowMore) {
				_that.$emit("closeClick");
			}
		},
		closeMessageAlertClick: function () {
			let _that = this;
			_that.messageFlag = false;
			_that.$emit("closeClick");
		},
		ignoreWakeUpTips: function () {
			let _that = this;
			_that.$common.localStorage.setItem("ignoreRemoteWakeupTips", true);
			_that.closeWakeUpTipsAlert();
		},
		showConnectFailed: function () {
			let _that = this;
			if (_that.isShowConnectAlert) {
				_that.isShowConnectFailed = true;
			}
		},
		showRuleModeAlert: function () {
			this.isShowRuleModeAlert = true;
		},
		hideRuleModeAlert: function (isShowMore) {
			let _that = this;
			_that.isShowRuleModeAlert = false;
			if (!isShowMore) {
				_that.$emit("closeClick");
			}
		},
		closeWakeUpTipsAlert: function () {
			let _that = this;
			_that.isShowWakeUpTipsAlert = false;
			_that.$emit("closeClick");
		},
		showWakeUpTipsAlert: function () {
			let _that = this;
			// console.log("showWakeUpTipsAlert");
			_that.closeWakeUpSuccessTipsAlert(true);
			_that.isShowWakeUpTipsAlert = true;
		},
		wakeupClick: function () {
			// console.log("wakeupClick");
			let _that = this;
			_that.showWakeUpSuccessTipsAlert();

			if (_that.$store.state.client == "windows") {
				if (window.external.goWakeUp) {
					let ret = window.external.goWakeUp(_that.item.mac);
					_that.sendUserlog(["wakeup_ret", ret + ""]);
				}
			} else {
				_that.webWakeup([
					_that.dev.peerid,
					_that.item.mac,
					function (err, data) {
						_that.sendUserlog([
							"wakeup_result",
							JSON.stringify(data),
						]);
						if (data && !data.rtn) {
							_that.scan([
								_that.dev.peerid,
								function (err, data) {},
							]);
						}
					},
				]);
			}
		},
		showWakeupTips: function () {
			let _that = this;
			_that.messageFlag = true;
			_that.messageType = "showRemoteWakeup";
		},
		onPayClick: function () {
			let _that = this;
			_that.$router.push({ path: "/home/vip" });
		},
		closeConnectAlert: function (isShowMore) {
			let _that = this;
			_that.isShowConnectFailed = false;
			_that.isShowConnectAlert = false;
			if (!isShowMore) {
				_that.$emit("closeClick");
			}
		},
		showConnectAlert: function () {
			let _that = this;
			_that.isShowConnectAlert = true;
		},
		controlClick: function (rule) {
			let _that = this;
			if (_that.$store.state.user.vip_left > 0) {
				_that.doControlClick();
			} else {
				_that.getServerTimes([
					function (err, data) {
						let leftTimes =
							data && data.data && data.data.times
								? data.data.times
								: 0;
						if (leftTimes > 0) {
							_that.doControlClick(rule);
						} else {
							_that.showServerTimesLimitAlert();
						}
					},
				]);
			}
		},
		doControlClick: function (rule) {
			let _that = this;
			rule = rule ? rule : 0;
			if (_that.item.rule) {
				rule = _that.item.rule;
			}
			_that.rule = rule;
			_that.connectName = _that.item.name;
			_that.connectRet = 0;
			_that.showConnectAlert();
			_that.hideRuleModeAlert(true);

			if (
				_that.$store.state.client != "windows" &&
				_that.$store.state.client != "mac"
			) {
				if (
					_that.item.port == 5000 ||
					_that.item.port == 80 ||
					_that.item.port == 8080 ||
					_that.item.port == _that.dev.term.nasWebPort ||
					_that.$store.state.nasExPorts.includes(_that.item.port)
				) {
				} else {
					_that.closeConnectAlert(true);
					_that.messageFlag = true;
					_that.messageType = "showDownloadWindowsApp";
				}
			}

			setTimeout(function () {
				_that.controlDelay(rule);
			}, 1500);
		},
		controlDelay: function (rule) {
			let _that = this;
			rule = rule ? rule : 0;
			_that.rule = rule;
			// _that.showRuleModeAlert();
			// return;
			// console.log("controlClick", _that.item, _that.dev);
			_that.showConnectAlert();
			_that.hideRuleModeAlert(true);
			let ip = _that.$common.ipConvert(_that.item.ip);
			let port = _that.item.port ? _that.item.port : 0;
			_that.connectName = _that.item.name;
			_that.connectRet = 0;
			_that.sendUserlog(["control_click", ip + ":" + port + "," + rule]);
			_that.sendUserlog([
				"control_" + port + "_click",
				ip + ":" + port + "," + rule,
			]);

			if (_that.$store.state.client == "windows") {
				let ret = 1;
				if (_that.item.port == 3389) {
					if (window.external.goMstsc) {
						ret = window.external.goMstsc(ip, 3389, 0);

						if (ret == 0 || ret == -2023) {
							_that.sendUserlog([
								"remote_s_windowsDesktop",
								ip + "|" + "3389",
							]);
						} else {
							_that.sendUserlog([
								"remote_f_windowsDesktop",
								ip + "|" + "3389",
							]);
						}
					}
				} else if (_that.item.port == 5900) {
					if (window.external.goVNCViewer) {
						ret = window.external.goVNCViewer(
							"tvnviewer.exe",
							ip,
							5900,
							0
						);

						if (ret == 0 || ret == -2023) {
							_that.sendUserlog([
								"remote_s_windowsVNC",
								ip + "|" + "5900",
							]);
						} else {
							_that.sendUserlog([
								"remote_f_windowsVNC",
								ip + "|" + "5900",
							]);
						}
					}
				} else if (
					_that.item.port == 5000 ||
					_that.item.port == 80 ||
					_that.item.port == 8080 ||
					_that.item.port == _that.dev.term.nasWebPort ||
					_that.$store.state.nasExPorts.includes(_that.item.port)
				) {
					if (window.external.goBrowser) {
						if (
							_that.item.vendor == "Huawei" &&
							_that.dev.term.version > "1.1.1"
						) {
							if (rule == 0) {
								setTimeout(function () {
									_that.closeConnectAlert(true);
									_that.showRuleModeAlert();
								}, 1000);
								return;
							}
							_that.sendUserlog(["remote_mode", ""]);
						}
						ret = window.external.goBrowser(
							ip,
							_that.item.port,
							rule
						);

						if (ret == 0 || ret == -2023) {
							_that.sendUserlog([
								"remote_s_windowsGoBrowser",
								ip + "|" + _that.item.port,
							]);
						} else {
							_that.sendUserlog([
								"remote_f_windowsGoBrowser",
								ip + "|" + _that.item.port,
							]);
						}
					}
				}
				_that.connectRet = ret;
				setTimeout(function () {
					// for test
					// ret = 0;
					if (ret == 0 || ret == -2023) {
						_that.doControlSuccess();
					} else {
						_that.showConnectFailed();
					}
				}, 500);
			} else if (_that.$store.state.client == "mac") {
				if (_that.item.port == 3389) {
					if (window.webkit.messageHandlers.goMstsc) {
						window.webkit.messageHandlers.goMstsc.postMessage({
							ip: ip,
							port: _that.item.port,
							rule: rule,
							cb: "goMstscCallback",
						});
					}
					// _that.closeConnectAlert(true);
					// _that.messageFlag = true;
					// _that.messageType = "showDownloadWindowsApp";
				} else if (
					_that.item.port == 5000 ||
					_that.item.port == 80 ||
					_that.item.port == 8080 ||
					_that.item.port == _that.dev.term.nasWebPort ||
					_that.$store.state.nasExPorts.includes(_that.item.port)
				) {
					if (window.webkit.messageHandlers.goBrowser) {
						if (
							_that.item.vendor == "Huawei" &&
							_that.dev.term.version > "1.1.1"
						) {
							if (rule == 0) {
								setTimeout(function () {
									_that.closeConnectAlert(true);
									_that.showRuleModeAlert();
								}, 1000);
								return;
							}
							_that.sendUserlog(["remote_mode", ""]);
						}

						window.webkit.messageHandlers.goBrowser.postMessage({
							ip: ip,
							port: _that.item.port,
							rule: rule,
							cb: "goBrowserCallback",
						});
					}
				}
			} else {
				if (
					_that.item.port == 5000 ||
					_that.item.port == 80 ||
					_that.item.port == 8080 ||
					_that.item.port == _that.dev.term.nasWebPort ||
					_that.$store.state.nasExPorts.includes(_that.item.port)
				) {
					if (
						_that.item.vendor == "Huawei" &&
						_that.dev.term.version > "1.1.1"
					) {
						if (rule == 0) {
							setTimeout(function () {
								_that.closeConnectAlert(true);
								_that.showRuleModeAlert();
							}, 1000);
							return;
						}
						_that.sendUserlog(["remote_mode", ""]);
					}
					//获取网关
					_that.portal([
						_that.dev.peerid,
						function (err, data) {
							if (data && data.rtn == 0) {
								let accessToken = data.data.access_token;
								let authToken = data.data.auth_token;
								let addr = "https://" + data.data.addr;

								//建立通道
								_that.createTunnel([
									_that.dev.peerid,
									accessToken,
									authToken,
									addr,
									function (err, data1) {
										if (
											!err &&
											data1 &&
											data1.status == 1
										) {
											//获取端口，打开新窗口

											_that.startMapSrv([
												_that.dev.peerid,
												accessToken,
												authToken,
												ip,
												_that.item.port,
												addr,
												rule,
												function (err, data2) {
													let reqLogData = {
														callee: _that.dev
															.peerid,
														authToken: authToken,
														accessToken:
															accessToken,
														svFwdIP: ip,
														svFwdPort:
															_that.item.port,
														addr: addr,
														rule: rule,
													};
													if (
														data2 &&
														data2.svMapPort
													) {
														let httpType = "http";
														if (
															data2.svMapPort ==
															443
														) {
															httpType = "https";
														}
														let url =
															httpType +
															"://" +
															data2.svMapHost +
															":" +
															data2.svMapPort +
															"/?jdcode=" +
															encodeURIComponent(
																authToken
															);

														let logObj = {
															url: url,
														};

														_that.sendUserlog([
															"remote_s_startMapSrv",
															JSON.stringify(
																reqLogData
															) +
																JSON.stringify(
																	data2
																) +
																JSON.stringify(
																	logObj
																),
														]);
														_that.$common
															.bridge(
																_that.$store
																	.state
																	.client
															)
															.openBrowser(url);
														_that.doControlSuccess();
													} else {
														_that.sendUserlog([
															"remote_f_startMapSrv",
															JSON.stringify(
																reqLogData
															) +
																JSON.stringify(
																	data2
																),
														]);
														_that.showConnectFailed();
													}
												},
											]);
										} else {
											_that.connectRet =
												data1 && data1.status
													? data1.status
													: "";
											_that.showConnectFailed();
										}
									},
								]);
							} else {
								_that.connectRet = data.rtn;
								_that.showConnectFailed();
							}
						},
					]);
				} else {
					_that.closeConnectAlert(true);
					_that.messageFlag = true;
					_that.messageType = "showDownloadWindowsApp";
				}
			}
		},
		doControlSuccess: function () {
			let _that = this;
			if (_that.$store.state.user.vip_left > 0) {
				_that.closeConnectAlert();
			} else {
				_that.closeConnectAlert(true);
				_that.showServerTimes();
			}
		},
		showServerTimes: function () {
			let _that = this;
			_that.updateServerTimes([
				function (err, data) {
					let leftTimes =
						data && data.data && data.data.times
							? data.data.times
							: 0;
					leftTimes = leftTimes >= 0 ? leftTimes : 0;
					_that.leftTimes = leftTimes;
					_that.showServerTimesTipsAlert();
				},
			]);
		},
		openClick: function () {
			let _that = this;
			_that.sendUserlog(["wakeup_click", _that.item.mac]);
			let isIgnoreRemoteWakeupTips = localStorage.getItem(
				"ignoreRemoteWakeupTips"
			);
			if (isIgnoreRemoteWakeupTips) {
				_that.wakeupClick();
			} else {
				_that.showWakeUpTipsAlert();
			}
		},
	},
	activated: function () {
		let _that = this;
		if (_that.type == "wakeup") {
			_that.openClick();
		} else {
			_that.controlClick();
		}
	},
	mounted: function () {
		let _that = this;

		// for test
		// setTimeout(function () {
		// 	window.goBrowserCallback({ isHandle: true, ret: 0 });
		// }, 2000);

		window.goBrowserCallback = function (data) {
			let ret = data.ret;
			_that.connectRet = ret;
			setTimeout(function () {
				if (ret == 0 || ret == -2023) {
					_that.doControlSuccess();
					_that.sendUserlog([
						"remote_s_macGoBrowser",
						JSON.stringify(data),
					]);
				} else {
					_that.showConnectFailed();
					_that.sendUserlog([
						"remote_f_macGoBrowser",
						JSON.stringify(data),
					]);
				}
			}, 500);
		};
		window.goMstscCallback = function (data) {
			let ret = data.ret;
			let isHandle = data.isHandle;
			_that.connectRet = ret;
			setTimeout(function () {
				if (ret == 0 || ret == -2023) {
					if (isHandle) {
						_that.doControlSuccess();

						_that.sendUserlog([
							"remote_s_macDesktop",
							JSON.stringify(data),
						]);
					} else {
						_that.closeConnectAlert(true);
						_that.messageFlag = true;
						_that.messageType = "showDownloadMacMstscApp";

						_that.sendUserlog([
							"remote_f_macDesktop_MRD",
							JSON.stringify(data),
						]); //Microsoft Remote Desktop
					}
				} else {
					_that.showConnectFailed();

					_that.sendUserlog([
						"remote_f_macDesktop",
						JSON.stringify(data),
					]);
				}
			}, 500);
		};
		// console.log("control type", _that.type, _that.item);
		if (_that.type == "wakeup") {
			_that.openClick();
		} else {
			_that.controlClick();
		}
	},
};
</script>

<style lang="less" scoped>
.control {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
}
</style>